import type { ResumeTypes } from "@/types";

export const skillsData: ResumeTypes.SkillItem[] = [
	{
		name: "Email",
		items: ["SPF", "DKIM", "DMARC", "Green Arrow", "Email Deliverability"],
	},
	{
		name: "Languages",
		items: ["Python", "Golang", "JavaScript", "TypeScript", "HTML", "CSS"],
	},
	{
		name: "Libraries & Frameworks",
		items: [
			"React",
			"Next.js",
			"Tailwind CSS",
			"Django",
			"FastAPI",
			"Gin",
			"Prisma",
			"React Router",
			"Tan Stack",
			"Zod",
		],
	},
	{
		name: "Service Providers",
		items: [
			"AWS",
			"DigitalOcean",
			"Vercel",
			"Cloudflare",
			"Railway",
			"Fly.io",
			"Hetzner",
		],
	},
];
